import { StringField, THeadingTag } from '../../../types/types';
import { TMediaGalleryProps } from '../types/mediaGallery.types';
import { getImageField } from '../../../utils/getImageFields';
import { getThumbnailProps } from '../../../utils/youtubeUtils';
import { TGalleryItem } from '../../@shared/overlayCarouselPopup/types/overlayCarouselPopup.types';

export class MediaGalleryModel {
  private readonly fields?;
  private readonly params?;

  constructor(props: TMediaGalleryProps) {
    this.fields = props?.fields || null;
    this.params = props?.params || null;
  }

  get slides(): Array<TGalleryItem> {
    if (this.fields?.items?.length > 0) {
      return this.fields?.items?.map((item) => {
        const { thumbnailImgSrc } = getThumbnailProps(item?.fields?.video?.value?.href || '');
        const desktopImage = getImageField(item?.fields?.image, thumbnailImgSrc || '', item?.fields?.useVideo?.value);
        const mobileImage = getImageField(item?.fields?.mobileImage, thumbnailImgSrc || '', item?.fields?.useVideo?.value);

        return {
          id: item.id,
          full: desktopImage,
          desktopImage: desktopImage,
          mobileImage: mobileImage,
          alt: desktopImage?.value?.alt,
          title: item.fields?.videoHeading,
          description: item.fields?.videoSubheading,
          isVideo: !!item.fields?.useVideo?.value,
          videoUrl: item.fields?.video?.value?.href,
        };
      });
    }
    return [];
  }

  get eyebrow(): StringField {
    return this.fields?.eyebrow;
  }

  get title(): StringField {
    return this.fields?.title;
  }

  get description(): StringField {
    return this.fields?.description;
  }

  get isUnreleased(): boolean {
    return !!this.fields?.isComponentUnreleased;
  }

  get headingTag(): THeadingTag {
    return (this.params?.headingTag?.toLowerCase() as THeadingTag) || 'h2';
  }
}
